module.exports = __webpack_public_path__ + "img/p9.fae442cc.png";